export const AXIS_LONG_NAME = 'longName';
export const NUMBER_OF_OBSERVATIONS = 'observations';
export const MAX_X_AXIS_SCORE = 'maxXAxisScore';
